import { computed, inject, provide } from "vue";

export const OVERLAY_Z_INDEX_KEY = "overlayZIndex";
export const OVERLAY_Z_INDEX_STEP = 10;
const KEY = OVERLAY_Z_INDEX_KEY;
const BASE = 9990;
const STEP = OVERLAY_Z_INDEX_STEP;

/**
 * Manages z-index stacking for overlay components (dialogs, menus, tooltips).
 *
 * Injects the nearest parent overlay's z-index and computes own z-index as
 * parent + step, then provides it for any nested overlay components.
 *
 * @returns {{ zIndex: import('vue').ComputedRef<number> }}
 * @example
 * const { zIndex } = useOverlayZIndex()
 * // use :style="{ zIndex }" on the floating element
 */
export function useOverlayZIndex() {
  const parent = inject(KEY, BASE);
  const zIndex = computed(() => {
    const val = typeof parent === "object" && parent !== null ? parent.value : parent;
    return val + STEP;
  });
  provide(KEY, zIndex);
  return { zIndex };
}
